import is from 'typescript-styled-is'
import styled, { ITheme } from '../../../theme'

export const Switch = styled.label<ISwitchProps>`
  position: relative;

  width: ${({ size }) => (size ? 36 * size : 36)}px;
  height: ${({ size }) => (size ? 22 * size : 22)}px;

  ${is('small')`
  	width: ${({ size }) => (size ? 26 * size : 26)}px;
  	height: ${({ size }) => (size ? 16 * size : 16)}px;
  `}

  & input {
    opacity: 0;
    width: 0;
    height: 0;
  }
`

export const Slider = styled.span<ISwitchProps>`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: ${({ size }) => (size ? 34 * size : 34)}px;

  &:before {
    position: absolute;
    content: '';

    height: ${({ size }) => (size ? 18 * size : 18)}px;
    width: ${({ size }) => (size ? 18 * size : 18)}px;
    left: ${({ size }) => (size ? 2 * size : 2)}px;
    bottom: ${({ size }) => (size ? 2 * size : 2)}px;

    ${is('small')`
    	height: ${({ size }) => (size ? 12 * size : 12)}px;
    	width: ${({ size }) => (size ? 12 * size : 12)}px;
    	left: ${({ size }) => (size ? 2 * size : 2)}px;
    	bottom: ${({ size }) => (size ? 2 * size : 2)}px;
    `};
    background-color: white;
    transition: 0.1s;
    border-radius: 50%;
  }
`

export const Input = styled.input<ISwitchProps>`
  &:checked + ${Slider} {
    background-color: ${(props: ITheme) => props.theme.colors.primary};
  }
  &:focus + ${Slider} {
    box-shadow: 0 0 1px ${(props: ITheme) => props.theme.colors.primary};
  }
  &:disabled + ${Slider} {
    background-color: #e9e9e9;
    cursor: not-allowed;
  }
  &:checked + ${Slider}:before {
    transform: translateX(${({ size }) => (size ? 14 * size : 14)}px);
    ${is('small')`
    	transform: translateX(${({ size }) => (size ? 10 * size : 10)}px);
  	`};
  }
`

export interface ISwitchProps {
  small?: boolean
  size?: number
}
